import { BRAND, waLink, DEFAULT_QUOTE_MESSAGE, EMAIL } from "../../lib/site";
import { Mail } from "lucide-react";
import { WhatsAppIcon, Logo } from "./bits";

export const Footer = () => (
    <footer
        data-testid="footer-section"
        className="relative overflow-hidden bg-ink pb-10 pt-20"
    >
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <div className="flex flex-col gap-12 border-b border-white/5 pb-14 lg:flex-row lg:justify-between">
                <div className="max-w-sm">
                    <Logo className="h-16 w-auto" />
                    <p className="mt-5 font-display text-xl font-bold uppercase italic text-mist">
                        {BRAND.tagline}
                    </p>
                    <p className="mt-3 text-sm leading-relaxed text-mute">
                        Sede em Brasília (DF) · Atendimento em todo o Brasil.
                        Transporte rodoviário de cargas com frota própria,
                        rastreio em tempo real e cobertura nacional.
                    </p>
                </div>

                <div className="flex flex-col gap-10 sm:flex-row sm:gap-20">
                    <div>
                        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-tangerine">
                            Navegação
                        </span>
                        <ul className="mt-5 space-y-3 text-sm text-mist/70">
                            <li>
                                <a href="#servicos" className="transition-colors hover:text-magenta">
                                    Serviços
                                </a>
                            </li>
                            <li>
                                <a href="#cotacao" className="transition-colors hover:text-magenta">
                                    Cotação
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-tangerine">
                            Contato
                        </span>
                        <ul className="mt-5 space-y-3 text-sm">
                            <li>
                                <a
                                    href={waLink(DEFAULT_QUOTE_MESSAGE)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-whatsapp-link"
                                    className="inline-flex items-center gap-2 text-zap transition-opacity hover:opacity-75"
                                >
                                    <WhatsAppIcon className="h-4 w-4" />
                                    WhatsApp
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${EMAIL}`}
                                    data-testid="footer-email-link"
                                    className="inline-flex items-center gap-2 text-mist/70 transition-colors hover:text-magenta"
                                >
                                    <Mail className="h-4 w-4" />
                                    {EMAIL}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={BRAND.instagramUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-instagram-link"
                                    className="text-mist/70 transition-colors hover:text-magenta"
                                >
                                    Instagram — {BRAND.instagram}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="flex items-center justify-between py-8 font-mono text-[10px] uppercase tracking-[0.2em] text-mute/60">
                <span>© {new Date().getFullYear()} {BRAND.name}</span>
                <span className="checkers inline-block h-3 w-3 opacity-50" />
                <span>Transportando com Excelência</span>
            </div>
        </div>

        <div
            aria-hidden="true"
            className="pointer-events-none select-none whitespace-nowrap text-center font-display text-[17vw] font-extrabold uppercase italic leading-[0.8] text-outline opacity-60"
        >
            Borges Cargas
        </div>
    </footer>
);
